import axios from 'axios';

const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);

export const resolveApiBaseURL = (locationLike = window.location, env = process.env) => {
  if (env.REACT_APP_API_BASE_URL) {
    return env.REACT_APP_API_BASE_URL;
  }

  if (LOCAL_HOSTS.has(locationLike.hostname)) {
    return 'http://localhost:12345';
  }

  return '';
};

export const configureApiClient = () => {
  axios.defaults.baseURL = resolveApiBaseURL();
};

